'use client';

import React from 'react';

interface Size {
  width: number;
  height: number;
}

export const useRefElementSize = <T extends HTMLElement = HTMLDivElement>(
  node: React.MutableRefObject<T | null>,
): Size => {
  const [size, setSize] = React.useState<Size>({
    height: 0,
    width: 0,
  });

  const handleSize = React.useCallback(() => {
    setSize({
      height: node.current?.offsetHeight || 0,
      width: node.current?.offsetWidth || 0,
    });
  }, [node]);

  React.useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => {
      if (!Array.isArray(entries) || !entries.length) {
        return;
      }
      handleSize();
    });

    if (node.current) {
      resizeObserver.observe(node.current);
    }
    return () => resizeObserver.disconnect();
  }, [handleSize, node]);

  return size;
};
